import React, { useMemo } from 'react';

import { Box } from '@mui/material';
import { useFeatureFlagEnabled } from 'posthog-js/react';

import Typography from '@/components/Typography';
import { GX_PROMPT_SHARE } from '@/constants/featureFlags';
import SharePromptButton from '@/features/AIChat/AskGXDrawer/components/SharePromptButton';
import TextType from '@/features/AIChat/AskGXDrawer/components/TextType/TextType';
import { useChat } from '@/features/AIChat/context/useChat';
import type { HumanMessage as HumanMessageType } from '@/features/AIChat/types/chat';

const HumanMessage = ({ msg }: { msg: HumanMessageType }) => {
  const promptShareEnabled = useFeatureFlagEnabled(GX_PROMPT_SHARE);
  const { animatedHumanId, animatedText, onAnimatedComplete } = useChat();

  const shouldAnimate = useMemo(() => {
    return animatedHumanId === msg.id && !!animatedText;
  }, [animatedHumanId, animatedText, msg.id]);
  return (
    <Box
      sx={{
        alignSelf: 'flex-end',
        maxWidth: '70%'
      }}
    >
      <Box
        sx={{
          padding: '12px',
          marginBottom: '12px',
          minWidth: '208px',
          backgroundColor: 'var(--GX-action-bar-button-tile, rgba(248, 248, 248, 0.20))',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}
      >
        <Typography
          component='div'
          sx={{ overflowWrap: 'break-word', hyphens: 'auto', fontSize: '14px' }}
        >
          <Box sx={{ fontWeight: 700 }}>You:</Box>
          <Box>
            {shouldAnimate ? (
              <TextType
                showCursor
                as='div'
                loop={false}
                text={animatedText as string}
                onComplete={onAnimatedComplete}
              />
            ) : (
              msg.text
            )}
          </Box>
        </Typography>
        {promptShareEnabled && <SharePromptButton prompt={msg.text} />}
      </Box>
    </Box>
  );
};

export default HumanMessage;
